// extracted by mini-css-extract-plugin
export default {"loaderBackdrop":"loader_loaderBackdrop__pYcA8","loaderCircle":"loader_loaderCircle__326Nc","spin":"loader_spin__XkrLf"};